export enum RegisterTypeEnum {
  CODE = 'CODE',
  PUBLIC = 'PUBLIC',
}
